<template>
  <div>
    <div class="item">文件名称： {{detail.file_name}}</div>
    <div class="item">
      <span>文件类型： </span>
      <span v-if="detail.file_type === '1'">图片</span>
      <span v-if="detail.file_type === '2'">视频</span>
      <span v-if="detail.file_type === '3'">文件</span>
    </div>
    <div class="item">分类名称： {{detail.class_name}}</div>
    <div class="item">创建时间： {{detail.create_time}}</div>
    <div class="item">更新时间： {{detail.update_time}}</div>
    <div class="item">最后更新人： {{detail.update_admin_name}}</div>
    <viewer
      class="img-wrap"
      v-if="detail.file_type === '1'"
    >
      <img
        :src="detail.file_key | imgMapper"
        class="img"
        title="点击查看大图"
      >
    </viewer>
    <video
      :src="detail.file_key | imgMapper"
      width="320"
      height="240"
      controls="controls"
      v-if="detail.file_type === '2'"
    >
      Your browser does not support the video tag.
    </video>
    <div class="btns-wrap">
      <el-button
        type="primary"
        @click="onDownLoadClick"
        v-if="operations.includes('下载文件')"
      >下载</el-button>
      <!-- 预览word excel -->
      <a
        :href="docHref"
        target="_blank"
        rel="nofollow"
        v-if="isDoc || isExcel || isPPT || isPDF"
        class="previewBtn"
      >预览</a>
      <!-- 预览excel -->
      <!-- <el-button
        type="primary"
        @click="previewExcel"
        v-if="isExcel"
      >预览excel</el-button> -->
      <!-- 预览pdf -->
      <!-- <el-button
        type="primary"
        @click="onViewPDF"
        v-if="isPDF"
      >预览</el-button> -->
    </div>
  </div>
</template>

<script>
import { getFileDetail } from "@/api/file-manage";
import { imgDomain } from "@/configs/env";
import utils from "@/jslibs/utils";

export default {
  data() {
    return {
      uuid: "",
      detail: {
        file_name: ""
      },
      operations: []
    };
  },
  components: {},
  mounted() {
    const { uuid, operations } = this.$route.query;
    if (uuid) {
      this.uuid = uuid;
      this._getFileDetail();
      this.operations = JSON.parse(operations);
    }
  },
  computed: {
    isPDF() {
      const reg = /(.pdf)$/;
      return reg.test(this.detail.file_name);
    },
    isOffice() {
      const reg = /([.docx|.doc|.xlsx|.xls|.pptx|.ppt])$/;
      return reg.test(this.detail.file_name);
    },
    isDoc() {
      return this.detail.file_name.indexOf("doc") !== -1;
    },
    isExcel() {
      return this.detail.file_name.indexOf("xls") !== -1;
    },
    isPPT() {
      return this.detail.file_name.indexOf("ppt") !== -1;
    },
    fileUrl() {
      return `${imgDomain}${this.detail.file_key}`;
    },
    docHref() {
      return `http://www.xdocin.com/xdoc?_func=to&_format=html&_cache=1&_xdoc=${
        this.fileUrl
      }`;
    }
  },
  methods: {
    async _getFileDetail() {
      const {
        status,
        data: { result: resData }
      } = await getFileDetail(this.uuid);
      if (status === 200) {
        this.detail = resData;
        console.log(resData, "detaoil");
      }
    },
    onViewPDF() {
      let url = `${imgDomain}${this.detail.file_key}?name=${
        this.detail.file_name
      }`;
      window.open(`/pdf/web/viewer.html?file=${url}`);
    },
    async onDownLoadClick() {
      let loading = vm.$loading({
        lock: true,
        text: "正在努力下载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let url = `${imgDomain}/${this.detail.file_key}`;
      const res = await utils.downloadFile(url, undefined, undefined, false);
      utils.downloadBlobFile(res.data, this.detail.file_name);
      loading.close();
    },
    previewExcel() {
      let url = `${imgDomain}/${this.detail.file_key}`;
      const { href } = this.$router.resolve({
        name: "preview-excel",
        query: {
          url
        }
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang='less' scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.item {
  margin-bottom: 20px;
}
.img {
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.btns-wrap {
  margin-top: 50px;
}
.previewBtn {
  display: inline-block;
  width: 70px;
  height: 40px;
  line-height: 40px;
  margin: 0 20px;
  color: #fff;
  background: #409eff;
  border: 1px solid #409eff;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
}
</style>